export default class Header {
    constructor() {

        this.initPaginationScroll();
        this.initMenuMobile();
        this.initSubMenuMobile();
        this.enableTooltips();
        this.initPortfolioToggle();
        this.initModals();
        this.initSubmenuHover();
        this.initCustomSelect();

        this.initBannerEventos();
        this.initGoToTop();
    }

    /* ---------------------------------------------------------
     * PAGINAÇÃO – Scroll automático
     * --------------------------------------------------------- */
    initPaginationScroll() {
        const params = new URLSearchParams(window.location.search);
        const paged = parseInt(params.get("paged"), 10);

        if (paged && paged > 1) {
            const target = document.querySelector('[data-component="listagem_artigos"]');
            if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    /* ---------------------------------------------------------
     * MENU MOBILE
     * --------------------------------------------------------- */
    initMenuMobile() {
        document.querySelectorAll('.button-menu-mobile').forEach(el => {
            el.addEventListener('click', () => {
                document.body.classList.toggle('disabled');
                document.querySelector('.menu-mobile').classList.toggle('open');

                document.querySelectorAll('.menu-mobile nav').forEach(nav => {
                    nav.classList.remove('open');
                });
            });
        });
    }

    initSubMenuMobile() {
        document.querySelectorAll('.sub-menu-button').forEach(el => {
            el.addEventListener('click', (e) => {
                e.currentTarget.closest('li').nextElementSibling.classList.add('open');
            });
        });

        document.querySelectorAll('.sub-menu-button-close').forEach(el => {
            el.addEventListener('click', (e) => {
                e.currentTarget.closest('nav').classList.remove('open');
            });
        });
    }

    /* ---------------------------------------------------------
     * TOOLTIP
     * --------------------------------------------------------- */
    enableTooltips(selector = "[data-tooltip]") {
        document.querySelectorAll(selector).forEach(el => {
            if (!el.querySelector(".tooltip-text")) {
                const span = document.createElement("span");
                span.className = "tooltip-text";
                span.textContent = el.getAttribute("data-tooltip");
                el.appendChild(span);
            }

            el.addEventListener("click", (e) => {
                e.stopPropagation();
                el.classList.toggle("show");
            });
        });

        document.addEventListener("click", () => {
            document.querySelectorAll(selector).forEach(el => el.classList.remove("show"));
        });
    }

    /* ---------------------------------------------------------
     * SINGLE PORTFÓLIO – Veja mais / ver menos
     * --------------------------------------------------------- */
    initPortfolioToggle() {
        const wrapper = document.querySelector('.pq-investimos');
        const btn = document.querySelector('.veja-mais-pq-investimos');

        if (!wrapper || wrapper.querySelectorAll('p').length <= 1) return;

        btn.classList.add('active');

        btn.addEventListener('click', () => {
            wrapper.classList.toggle('active');
            btn.innerText = wrapper.classList.contains('active') ? "Ver menos" : "Veja mais";
        });
    }

    /* ---------------------------------------------------------
     * MODAL
     * --------------------------------------------------------- */
    initModals() {
        document.querySelectorAll('.close-modal').forEach(el => {
            el.addEventListener('click', (e) => {
                e.currentTarget.closest('[data-modal]').classList.remove('opened');
            });
        });

        document.querySelectorAll('[data-modal-open]').forEach(el => {
            el.addEventListener('click', (e) => {
                const target = e.currentTarget.dataset.modalOpen;
                document.querySelector(`[data-modal="${target}"]`).classList.add('opened');
            });
        });

        document.querySelectorAll("[data-modal]").forEach(modal => {
            modal.addEventListener("click", (e) => {
                const container = modal.querySelector(".modal-container");
                if (container && !container.contains(e.target)) modal.classList.remove("opened");
            });
        });
    }

    /* ---------------------------------------------------------
     * PRIMEIRO BANNER
     * --------------------------------------------------------- */
    initBannerEventos() {
        const banners = document.querySelectorAll('[data-component="banner_evento"]');
        if (banners.length > 0) banners[0].classList.add('firstItem');
    }

    /* ---------------------------------------------------------
     * GO TO TOP + círculo animado
     * --------------------------------------------------------- */
    initGoToTop() {
        this.btnTop = document.querySelector('.btnGoToTop');
        this.progressCircle = document.querySelector('.progress-circle');

        if (!this.btnTop || !this.progressCircle) return;

        this.circlePerimeter = 160.22;
        this.SCROLL_THRESHOLD = 200;

        window.addEventListener('scroll', () => this.handleScroll());
        window.addEventListener('load', () => {
            this.handleScroll();
            this.handleProgress();
        });

        this.btnTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    handleScroll() {
        const active = window.scrollY >= this.SCROLL_THRESHOLD;
        this.btnTop.classList.toggle('active', active);
        this.handleProgress();
    }

    handleProgress() {
        const total = document.documentElement.scrollHeight - window.innerHeight;
        const progress = Math.min(1, window.scrollY / total);

        const offset = this.circlePerimeter * (1 - progress);
        this.progressCircle.style.strokeDashoffset = offset;
    }

    /* ---------------------------------------------------------
     * SUBMENU (hover/focus)
     * --------------------------------------------------------- */
    initSubmenuHover() {
        const submenus = document.querySelectorAll("ul.sub-menu");

        submenus.forEach(ul => {
            const items = ul.querySelectorAll("a.group\\/submenu");
            if (!items.length) return;

            const first = items[0];
            items.forEach(i => i.classList.remove("is-active"));
            first.classList.add("is-active");

            items.forEach(item => {
                item.addEventListener("pointerenter", () => {
                    items.forEach(i => i.classList.remove("is-active"));
                    item.classList.add("is-active");
                });

                item.addEventListener("focus", () => {
                    items.forEach(i => i.classList.remove("is-active"));
                    item.classList.add("is-active");
                });
            });

            ul.addEventListener("pointerleave", () => {
                items.forEach(i => i.classList.remove("is-active"));
                first.classList.add("is-active");
            });
        });
    }

    /* ---------------------------------------------------------
    * CUSTOM SELECT
    * --------------------------------------------------------- */
    initCustomSelect() {
        document.querySelectorAll('[data-custom-select]').forEach(wrapper => {

            const select = wrapper.querySelector('select');
            const display = wrapper.querySelector('.select-display');
            const arrow = wrapper.querySelector('.select-arrow');
            const options = wrapper.querySelector('.select-options');

            display.addEventListener('click', (e) => {
                e.preventDefault(); // garante que nunca submeta
                e.stopPropagation();
                const isOpen = !options.classList.contains('hidden');
                options.classList.toggle('hidden');
                arrow.classList.toggle('is-open', !isOpen);
            });

            // --- selecionar opção ---
            options.querySelectorAll('li').forEach(li => {
                li.addEventListener('click', () => {
                    const value = li.dataset.value;
                    display.firstChild.textContent = li.textContent;

                    select.value = value;

                    options.querySelectorAll('li').forEach(x => x.removeAttribute('aria-selected'));
                    li.setAttribute('aria-selected', 'true');

                    options.classList.add('hidden');
                    arrow.classList.remove('is-open');

                    select.dispatchEvent(new Event('change'));
                });
            });

            // --- clique fora ---
            document.addEventListener('click', e => {
                if (!wrapper.contains(e.target)) {
                    options.classList.add('hidden');
                    arrow.classList.remove('is-open');
                }
            });
        });
    }

}
new Header();
